import * as React from 'react';
import { FC } from 'react';

import { ActionButtonVariants } from 'components/action-button';
import { ILinkWidgetFragment } from 'generated/sanity-graphql';

import { StyledButton } from './loyalty-button-widget.styled';

export interface ILoyaltyButtonWidgetProps {
  link: ILinkWidgetFragment;
}

const LoyaltyButtonWidget: FC<ILoyaltyButtonWidgetProps> = ({ link: linkProp }) => {
  const { text, link } = linkProp;

  return (
    <StyledButton
      data-testid="button-widget"
      to={link?.locale || ''}
      variant={ActionButtonVariants.OUTLINE}
    >
      {text?.locale}
    </StyledButton>
  );
};

export default LoyaltyButtonWidget;
